// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3EU5d","requiredAsterisk":"Info_requiredAsterisk__3xLTA"};